import React from 'react';
import { IIcon } from '../interfaces';

function Uncollapse({ onClick, type, color, className, styles }: IIcon.Props) {

    return (
        <i className={`fa${type ? type?.substr(0,1) : "s"} fa-angle-double-right ${className ?? ""} text-${color}`} onClick={onClick} style={styles}> </i>
    )
}

export default Uncollapse;